enum AppMode
{
    GuestMode = "Guest Mode",
    PromoterMode = "Promoter Mode",
}

export default AppMode